import { createMacroAllocationId } from "src/allocation/util/macroAllocation";
import { getForecastReadonlyFlag } from "src/allocation/util/allocationProject";
import { calculateTotalCost } from "src/allocation/util/budgetAndCost";
import newCell from "../newCell";
import getDefaultValueFromPreviousCell from "../../getDefaultValueFromPreviousCell";

export default (
  lineItem,
  previousCell,
  targetGroupId,
  sourceGroupId,
  column,
  rootGroup,
  enableDemandRequest = false
) => {
  const { isStatic, allocationProject } = column;
  const { dailyRate, grouping } = lineItem;
  const { isMovedOut } = grouping;
  const {
    id: allocationProjectId,
    isActive,
    enableRequirementInput,
    workingDays,
  } = allocationProject;
  const isReadonly = getForecastReadonlyFlag(allocationProject, rootGroup);

  let defaultedValue;
  let totalCost;

  if (isMovedOut) {
    defaultedValue = 0;
    totalCost = null;
  } else {
    defaultedValue = getDefaultValueFromPreviousCell(
      previousCell,
      allocationProject
    );
    totalCost = isActive
      ? null
      : calculateTotalCost({ value: defaultedValue, dailyRate, workingDays });
  }

  const macroAllocationId = createMacroAllocationId(
    allocationProjectId,
    sourceGroupId,
    targetGroupId,
    lineItem.type
  );
  return newCell({
    lineItem,
    column,
    columnType: column.columnType,
    id: macroAllocationId,
    macroAllocationId,
    targetGroupId,
    sourceGroupId,
    allocationProjectId,
    isStatic,
    isEditable: !enableDemandRequest && !isStatic && !isActive && !isReadonly,
    isRequirementInputEnabled: enableRequirementInput,
    defaultedValue,
    totalCost,
    dailyRate,
    workingDays,
  });
};
